module.exports = __webpack_public_path__ + "img/ico-drag.1113f79a.svg";